module.exports = __webpack_public_path__ + "img/hair-salon.92077e26.svg";